import { createAction } from 'Utility/Redux';
import { PlinkoReward } from 'System/Plinko/PlinkoReward';
import { Random } from 'Utility/Random';
import { IAPReward } from 'Utility/RewardHelper';

enum Types {
    DROP_PLINKO_TOKEN = 'dropPlinkoToken',
    BUY_PLINKO_TOKEN = 'buyPlinkoToken',
    SET_PLINKO_REWARD_CLAIMABLE = 'setPlinkoRewardClaimable',
    REWARD_ANIM_COMPLETE = 'rewardAnimComplete',
    CLAIM_PLINKO_REWARD = 'claimPlinkoReward',
    LEAVE_PLINKO_SCENE = 'leavePlinkoScene',
}

export const PlinkoActions = {
    dropToken: createAction(
        Types.DROP_PLINKO_TOKEN,
        resolve => (startIndex: number, anim: string, rewards: Random.IWeightedItem<PlinkoReward>[]) =>
            resolve<{
                startIndex: number;
                anim: string;
                rewards: Random.IWeightedItem<PlinkoReward>[];
            }>({ startIndex, anim, rewards })
    ),
    buyToken: createAction(Types.BUY_PLINKO_TOKEN, resolve => (product: IAPReward) => resolve(product)),
    setRewardClaimable: createAction(Types.SET_PLINKO_REWARD_CLAIMABLE),
    rewardAnimationComplete: createAction(Types.REWARD_ANIM_COMPLETE),
    claimReward: createAction(Types.CLAIM_PLINKO_REWARD, resolve => () => resolve()),
    leavePlinkoScene: createAction(Types.LEAVE_PLINKO_SCENE, resolve => () => resolve()),
};
